import React from 'react';
import { Calendar, ConfigProvider } from 'antd';
import moment, { Moment } from 'moment-timezone';
import classNames from 'classnames';
import { BringgDesktopCalendarProps } from '../../bringg-calendar.types';
import styles from './bringg-desktop-calendar.module.scss';
import enUS from 'antd/lib/locale/en_US';

const BringgDesktopCalendar = ({
	value,
	showYearNavigation,
	onChange,
	minDateNav,
	maxDateNav,
	dateCellRender,
	fullscreen,
	shouldDisableDate,
	className
}: BringgDesktopCalendarProps) => {
	const getValidRange = () => {
		const min = minDateNav ? moment(minDateNav) : moment().subtract(100, 'year');
		const max = maxDateNav ? moment(maxDateNav) : moment().add(100, 'year');
		return [min, max];
	};

	const validRange = minDateNav || maxDateNav ? getValidRange() : undefined;
	const disabledDate = shouldDisableDate ? (date: Moment) => shouldDisableDate(date) : undefined;
	const dateCellRenderer = dateCellRender ? (date: Moment) => dateCellRender(date) : undefined;

	const calendarClassNames = classNames(className, styles.baseCalendar, {
		[styles.hideYearNavigation]: !showYearNavigation
	});

	return (
		<ConfigProvider locale={enUS}>
			<Calendar
				value={moment(value)}
				onSelect={onChange}
				className={calendarClassNames}
				fullscreen={fullscreen}
				validRange={validRange as [Moment, Moment]}
				disabledDate={disabledDate}
				dateCellRender={dateCellRenderer}
			/>
		</ConfigProvider>
	);
};

export default BringgDesktopCalendar;
